import { FavoriteStorage } from './local-storage-functions';
import { toggleFavorite } from './autocompletev2.js'; // Importa a função central!
import LocalStorageHelper from './local-storage-helper.js';

export function initializeForecastFavoriteButton() {
  const button = $('#forecastFavButton');
  if (!button.length) {
    return;
  }

  const icon = button.find('img');
  const city = JSON.parse(button[0].dataset.info);
  const cityData = LocalStorageHelper.mapCityData(city)

  const updateUI = (isFavorited) => {
    const iconName = isFavorited ? 'star-filled' : 'star-empty';
    const title = isFavorited ? 'Remover dos favoritos' : 'Favoritar cidade';
    icon.attr('src', `/dist/images/v2/svg/${iconName}.svg`);
    button.attr('title', title);
  };

  const isInitiallyFavorited = FavoriteStorage.get().some(f => f.city.cid === cityData.cid);

  updateUI(isInitiallyFavorited);

  if (!window._forecastFavListenerAdded) {
    document.addEventListener('favoriteChanged', (e) => {
      if (e.detail.city.cid === cityData.cid) {
        updateUI(e.detail.isFavorited);
      }
    });
    window._forecastFavListenerAdded = true;
  }

  button.off('click').on('click', () => {
    toggleFavorite(cityData, 'Card_Forecast_Button_Star', 'city');
  });
}
